<template>
  <button  class="primary loader">
    This is a secret 9489
  </button>
</template>

<script>

export default {
    name:'ButtonLoader',
}
</script>

<style lang="scss"  scoped>
//buttons
.primary{
  color:transparent;
  outline: none;
  width: 80%;
  height:15%;
  margin: 5% auto; 
  background: transparent;
  transition: border-radius .5s ease-in-out;
  display:flex;
  font-family: Montserrat;
  font-size: 19px;
  border:0;
}

button:active {
  border-style: outset;
}
.my-auto{
    margin: auto 0;
    width: stretch;
}
.icon{
  margin-left:7%;
}
.smooth{
  border-radius: 100px;
}
.sharp{
  border-radius:0;
}
.filled{
  border:none;
}
.empty{
  border:solid 2px
}

.loader {
  background: linear-gradient(115deg, #e7e7e7, #b8b8b8);
  background-size: 400% 400%;
  animation: Loading 1s ease infinite;
}

@keyframes Loading {
    0%{background-position:23% 0%}
    50%{background-position:78% 100%}
    100%{background-position:23% 0%}
}
</style>